import Page from '@admin/components/page'
import Overview from './overview'
import Subdomains from './subdomains'
import React from 'react'
import Sent from './sent'
import Tlds from './tlds'

const mapPropsToPage = (props, context, resources, page) => ({
  title: resources.segment.text,
  manager: {
    path: `/admin/truevail/admin/segments/${resources.segment.id}`,
    items: [
      {
        label: 't(Overview)',
        panel: <Overview segment={ resources.segment } />
      },
      {
        label: 't(TLDs)',
        path: '/tlds',
        panel: <Tlds segment={ resources.segment } />
      },
      {
        label: 't(Subdomains)',
        path: '/subdomains',
        panel: <Subdomains segment={ resources.segment } />
      },
      {
        label: 't(Sent)',
        path: '/sent',
        panel: <Sent segment={ resources.segment } />
      }
    ]
  }
})

const mapResourcesToPage = (props, context) => ({
  segment: `/api/admin/truevail/admin/deliverability/segments/${props.params.id}`
})

export default Page(mapResourcesToPage, mapPropsToPage)